/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "@/models";
import { useRouter, } from "next/navigation";
import { useTranslation } from "@/i18n/client";


import UKDialog from "@/common-components-src/components/UKDialog";


import Styles from "./index.module.scss";
import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";

interface PayRiskModalProps {
  content: string;
  open: boolean;
  onClose: () => void;
  onOk: () => void;
}
// 支付风险弹窗
const PayRiskModal = observer((props: PayRiskModalProps) => {
  return <UKDialog open={open}
    onClose={props.onClose}
    showCloseBtn={false}
    sx={{
      "& .MuiDialog-paper": {
        width: "380px", // 设置自定义宽度
        maxWidth: "none", // 取消最大宽度限制
      },
    }}
  >
    <DialogTitle />

    {/* Error info */}
    <DialogContent className={Styles.payError}>{props.content}</DialogContent>

    {/* Button */}
    <DialogActions>
      <Button
        onClick={props.onClose}
        className={Styles.button} size="small" variant="outlined">
        Pay later
      </Button>
      <Button
        onClick={props.onOk}
        className={Styles.button} size="small" variant="contained">
        Try other payment methods
      </Button>
    </DialogActions>
  </UKDialog>
});

export default PayRiskModal;
